<template>
  <div v-if="isNoMrzFound && !isDocumentEditEnabled" class="info-text">
    {{ $t("mrz_failed_to_read_code") }}
  </div>
  <mrz-lines-list
    v-else
    :is-document-edit-enabled="isDocumentEditEnabled"
    :field-values="fieldValues"
    :action-in-progress="actionInProgress"
    :document-updating="documentUpdating"
    :mrz-lines-count="mrzLinesCount"
    @field-change="$emit('field-change', $event)"
  />
</template>

<script>
import { MRZ_FIELDS } from "@/constants/mrz";
import MrzLinesList from "./MrzLinesList";

export default {
  props: {
    currentIdentification: { type: Object, default: null },
    documentUpdating: { type: Boolean, default: false },
    isDocumentEditEnabled: { type: Boolean, default: false },
    fieldValues: { type: Object, default: null },
    actionInProgress: { type: Boolean, default: false }
  },

  emits: ["field-change"],

  data() {
    return {
      MRZ_FIELDS,
      originalFieldValues: null,
      document: null,
      initialDocument: null
    };
  },

  computed: {
    mrzLinesCount() {
      return {
        [MRZ_FIELDS.MRZ_1]: this.fieldValues[MRZ_FIELDS.MRZ_1]?.length,
        [MRZ_FIELDS.MRZ_2]: this.fieldValues[MRZ_FIELDS.MRZ_2]?.length,
        [MRZ_FIELDS.MRZ_3]: this.fieldValues[MRZ_FIELDS.MRZ_3]?.length
      };
    },

    isNoMrzFound() {
      return !Object.values(this.mrzLinesCount).some(value => value > 0);
    }
  },

  components: {
    MrzLinesList
  }
};
</script>

<style scoped lang="scss">
.info-text {
  margin-bottom: 1rem;
}
</style>
